export default "__VITE_ASSET__04127442__"